<template>
  <div v-if="item.type == 'button'" style="position:relative" class="item-button">
    <div v-if="!preview">
      <vs-dropdown vs-custom-content vs-trigger-click class='btn-delete'>
        <vs-button
          v-if="!preview"
          style="cursor: pointer;"
          radius
          color="danger"
          type="flat"
          icon-pack="feather"
          icon="icon-trash"
        ></vs-button>
        <vs-dropdown-menu class="dropdown-login">
          <div class="dropdownMenu">
            <div class="d-flex" style="justify-content:space-between">
              <h3 class="mb-3">Supprimer ?</h3>
            </div>
            <vs-button
              style="width:100% !important;"
              @click="remove()"
              color="danger"
              type="filled"
              icon-pack="feather"
              icon="icon-check"
              size="flat"
            ></vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <div
        :style="'display:flex; width:100%;justify-content:' + this.flexPosition"
      >
        <a
          :contenteditable="contenteditable"
          :href="item.location"
          :target="item.typeLocation ? '' : '_blank'"
          class="button"
          ref="btnConten"
          :style="'width:'+ item.width"
        >
          <quill-editor
            v-model="item.content"
            :disabled="!contenteditable"
            :options="editorOption"
          >
            {{ item.content }}
          </quill-editor>
        </a>
      </div>

      <input
        v-if="editLink && !preview"
        type="text"
        v-model="link"
        @blur="save"
        class="edit"
      />
      <vs-dropdown vs-custom-content vs-trigger-click
          class='btn-settings border-primary'>
        <vs-button
          v-if="!preview"
          style="cursor: pointer;"
          radius
          color="primary"
          class="border-primary"
          type="flat"
          icon-pack="feather"
          icon="icon-settings"
        ></vs-button>
        <vs-dropdown-menu class="dropdown-login">
          <div class="dropdownMenu">
            <div class="d-flex" style="justify-content:space-between">
              <h4 class="mb-3">Paramètres</h4>
              <vs-switch style="width:70px" v-model="switch1">
                <span slot="on">FICHIER</span>
                <span slot="off">LIEN</span>
              </vs-switch>
            </div>
            <vs-button
              v-if="switch1"
              style="cursor: pointer;"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-folder"
              class="éedit mb-4 mt-3"
              @click="togglePopupFiles(true)"
            >
              Gestion documentaire
            </vs-button>

            <label v-if="!switch1">URL : </label>
            <vs-input
              class="form-control edit mb-4"
              type="text"
              style="width:100%"
              v-model="item.location"
              @blur="saveLocation"
              v-if="!switch1"
            />
            <label v-if="!switch1">Ouverture : </label>
            <div style="width:100%;">
              <vs-switch
                v-if="!switch1"
                style="width:95px; float:right"
                v-model="item.typeLocation"
              >
                <span slot="on">Cette page</span>
                <span slot="off">Nouvelle page</span>
              </vs-switch>
            </div>
            <label>Largeur : </label>
            <vs-input-number
                label="Taille (%)"
                class="m-0 mb-4"
                v-model="widthElement"
                value="0"
                max="100"
                step="5"
              />
            <label >Position : </label>
            <div style="width:100%;">
              <ul class="d-flex">
                <li>
                  <vs-radio
                    class="m-2"
                    v-model="flexPosition"
                    vs-value="flex-start"
                    >Gauche</vs-radio
                  >
                </li>
                <li>
                  <vs-radio class="m-2" v-model="flexPosition" vs-value="center"
                    >Centre</vs-radio
                  >
                </li>
                <li>
                  <vs-radio class="m-2" v-model="flexPosition" vs-value="flex-end"
                    >Droite</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
      <PopupFiles
        @imageSrc="fileSrc"
        @closePopupFiles="togglePopupFiles"
        :activePopupFiles="activePopupFiles"
      ></PopupFiles>
    </div>

    <div v-else>
      <div :style="'display:flex;width:100%;justify-content:' + item.flexPosition">
        <a
          :href="item.location"
          :target="item.typeLocation ? '' : '_blank'"
          class="button"
          ref="btnConten"
          :style="'width:' + item.width"
        >
          <div v-html="item.content"></div>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import PopupFiles from "@/layouts/components/popup/PopupFiles";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

var toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  [{ size: ["small", false, "large", "huge"] }], // custom dropdown,
  [{ align: [] }],
  ["clean"], // remove formatting button
];

export default {
  props: [
    "preview",
    "contenteditable",
    "item",
    "colIndex",
    "rowIndex",
    "layout",
    "index",
  ],
  data() {
    return {
      flexPosition: "center",
      editLink: false,
      link: "",
      switch1: true,
      activePopupFiles: false,
      switch2: false,
      editorOption: {
        theme: "bubble",
        placeholder: "",
        modules: {
          toolbar: toolbarOptions,
        },
      },
    };
  },
  computed: {
    widthElement() {
      if(!this.item.width || this.item.width=="auto"){
        return 0
      }else{
        return this.item.width.substring(0, -1);
      }
    },
  },
  watch:{
    flexPosition: function (newVal, oldVal) {
      this.item.flexPosition=newVal
      this.flexPosition=newVal
    },
    widthElement: function (newVal, oldVal) {
      if(newVal==0){
        this.item.width="auto"
        this.widthElement="0"
      }else{
        this.item.width=newVal+"%"
        this.widthElement=newVal
      }
    },
  },
  created(){
    if(!this.item.flexPosition){
      this.item.flexPosition="center"
    }
    console.log("ITEM : ", this.item)
  },
  methods: {
    togglePopupFiles(val = false) {
      this.activePopupFiles = val;
    },
    fileSrc(data) {
      this.item.location = data;
    },
    saveFlexPosition(e){
      this.item.flexPosition=this.flexPosition
    },
    saveLocation(e) {
      this.item.location = e.target.value;
    },
    remove() {
      this.layout[this.rowIndex].col[this.colIndex].content.splice(
        this.index,
        1
      );
    },
    save(e) {
      this.item.location = e.target.value;
    },
  },
  components: {
    PopupFiles,
    quillEditor,
  },
};
</script>

<style scoped>
.preview {
  position: absolute;
  right: 4px;
  bottom: 4px;
}

.edit {
  float: right;
  width: 90%;
}

a {
  color: black;
}

.dropdownMenu {
  padding: 10px;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}


</style>
